import { useState, useCallback, useEffect } from 'react';
import type { ClaudeEvent } from '../types';

const MAX_EVENTS = 500;

export function useEvents(options: { initialFetch?: boolean; limit?: number } = {}) {
  const { initialFetch = true, limit = 100 } = options;

  const [events, setEvents] = useState<ClaudeEvent[]>([]);
  const [loading, setLoading] = useState(false);

  const addEvent = useCallback((event: ClaudeEvent) => {
    setEvents(prev => [...prev, event].slice(-MAX_EVENTS));
  }, []);

  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      const apiBase = import.meta.env.VITE_API_URL || '';
      const response = await fetch(`${apiBase}/api/events?limit=${limit}`);
      if (response.ok) {
        setEvents(await response.json());
      }
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    if (initialFetch) fetchEvents();
  }, [initialFetch, fetchEvents]);

  return { events, addEvent, fetchEvents, loading };
}
